import * as React from 'react'
import Grid from "@mui/material/Grid"
import heroPhoneImg from '../../assets/img/hero-phone.png'
import liveStreamHeart from '../../assets/img/live-stream-hearts.gif'
import Typography from '@mui/material/Typography'
import HeroBackgroundImg from '../../assets/img/hero-background.jpeg'
import HeroBackgroundVideo from '../../assets/video/hero-background.mp4'
import HeroMenuButton from "./HeroMenuButton"
import {getIconBySocial} from "../../utils"
import SinDividerWhiteImg from '../../assets/img/sin-divider-white.svg'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Button from "@mui/material/Button"
import {
  scroller
} from "react-scroll";
import {orange} from '@mui/material/colors'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';


const gradientTextStyles = {
  background: 'linear-gradient(90deg, #FFFFFF, #F48FB1)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  display: 'block',
  textSizeAdjust: '85%',
}

const Hero = ({groupedCategories, category}) => {
  const videoRef = React.useRef(null)

  const scrollToPricing = () => {
    scroller.scrollTo("pricing-scroll-element", {
      duration: 1000,
      delay: 0,
      smooth: "easeInOutQuint",
      offset: -80,
    });
  }

  React.useEffect(() => {
    const v = videoRef.current
    if (v) {
      v.muted = true
      v.defaultMuted = true
      v.playsInline = true
      try { v.setAttribute('webkit-playsinline', 'true') } catch (e) {}
      try { v.setAttribute('x-webkit-airplay', 'deny') } catch (e) {}
      try { v.setAttribute('disableRemotePlayback', '') } catch (e) {}
    }
  }, [])

  const getHeroTitle = (category) => {
    if (!category || !category.title) return ''

    if (category.title.toLowerCase() === 'instagram likes' || category.title.toLowerCase() === 'tiktok likes') {
      return <span>
        Buy Exclusive VIP <br/>
        {category.title} <br/>
        <span style={gradientTextStyles}> with Instant Delivery <RocketLaunchIcon sx={{color: '#F8BBD0'}}/></span>
      </span>
    } else if (category.title.toLowerCase() === 'instagram followers' || category.title.toLowerCase() === 'tiktok followers') {
      return <span>
        Buy Exclusive VIP <br/>
        {category.title} <br/>
        <span style={gradientTextStyles}> with Instant Delivery <RocketLaunchIcon sx={{color: '#F8BBD0'}}/></span>
      </span>
    } else if (category.title.toLowerCase() === 'instagram views' || category.title.toLowerCase() === 'tiktok views') {
      return <span>
        Buy {category.title} <br/>
        <span style={gradientTextStyles}> with Instant Delivery <RocketLaunchIcon sx={{color: '#F8BBD0'}}/></span>
      </span>
    } else {
      return `Buy ${category.title}`
    }
  }

  return (
    <div className={'hero'}>
      {/*<video*/}
      {/*  ref={videoRef}*/}
      {/*  preload="metadata"*/}
      {/*  autoPlay*/}
      {/*  loop*/}
      {/*  muted*/}
      {/*  defaultMuted*/}
      {/*  playsInline*/}
      {/*  poster={HeroBackgroundImg}*/}
      {/*  className="hero-background"*/}
      {/*  aria-hidden="true"*/}
      {/*  tabIndex={-1}*/}
      {/*  webkit-playsinline="true"*/}
      {/*  x-webkit-airplay="deny"*/}
      {/*  disableRemotePlayback*/}
      {/*>*/}
      {/*  <source src={HeroBackgroundVideo} type="video/mp4"/>*/}
      {/*</video>*/}

      <div className={'hero-container'}>
        <Grid className={'hero-grid'} container>
          <Grid item xs={12} sm={12} md={6}>
            <div className={'hero-text-container'}>
              {category ?
                <div>
                  <Typography className={'hero-text-1'} variant="h3" component="h1">
                    {getHeroTitle(category)}
                  </Typography>

                  <Typography variant="h5" gutterBottom component="h4" color={orange[100]}>
                    {category.short_description}
                  </Typography>

                  <Typography variant="subtitle1" gutterBottom component="p" color={'text.lightSecondary'}>
                    {category.long_description}
                  </Typography>

                  <br/>

                  {groupedCategories ?
                    groupedCategories.map((item, index) => {
                      return (
                        <HeroMenuButton
                          key={index}
                          title={`${item.social_display} Packages`}
                          icon={getIconBySocial(item.social_display)}
                          items={item.categories}
                        />
                      )
                    }) :
                    <div className={'hero-button-container'}>
                      <Button
                        startIcon={<ShoppingCartIcon/>}
                        color={'secondary'}
                        variant="contained"
                        onClick={scrollToPricing}
                        className={'hero-button'}
                        size={'large'}
                      >
                        Buy Now
                      </Button>
                    </div>
                  }
                </div>

                :

                <div>
                  <Typography className={'hero-text-1'} variant="h3" component="h1">
                    Buy Instagram & TikTok Followers, Likes & Views <br/> <span style={gradientTextStyles}>Delivered in Minutes <RocketLaunchIcon sx={{color: '#F8BBD0'}}/></span>
                  </Typography>

                  <Typography className={'hero-text-2'} variant="subtitle1" component="p">
                    Real and active accounts delivered with ultra-fast speed and high retention rates.
                    Our services are stable, secure and trusted worldwide — no password required.
                  </Typography>

                  <div className={'hero-button-container'}>
                    {groupedCategories ?
                      groupedCategories.map((item, index) => {
                        return (
                          <HeroMenuButton
                            key={index}
                            title={`${item.social_display} Packages`}
                            icon={getIconBySocial(item.social_display)}
                            items={item.categories}
                          />
                        )
                      })
                      :
                      <Button
                        startIcon={<ShoppingCartIcon/>}
                        color={'secondary'}
                        variant="contained"
                        onClick={scrollToPricing}
                        className={'hero-button'}
                        size={'large'}
                      >
                        Buy Now
                      </Button>
                    }
                  </div>
                </div>
              }
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <div className={'hero-phone-img-container'}>
              <img className={'hero-phone-img'} src={heroPhoneImg} alt={'Phone'}/>
              <img className={'live-stream-hearts-img'} src={liveStreamHeart} alt={'Phone'}/>
            </div>
          </Grid>
        </Grid>
      </div>

      <img className={'sin-divider-bottom'} src={SinDividerWhiteImg} alt={''}/>
    </div>
  )
}

export default Hero
